module.exports = __webpack_public_path__ + "static/media/12-3.f3399fe0.mp3";